function omit<T extends {}, K extends keyof T = keyof T>(obj: T | undefined, ...keys: K[]): Omit<T, K> {
  if (!obj) {
    return {} as T;
  }
  const copy = { ...obj };
  keys.forEach((key) => {
    delete copy[key];
  });
  return copy;
}

function pick<T extends {}, K extends keyof T = keyof T>(obj: T | undefined, ...keys: K[]): Pick<T, K> {
  if (!obj) {
    return {} as Pick<T, K>;
  }
  const copy = {} as Pick<T, K>;
  keys.forEach((key) => {
    copy[key] = obj[key];
  });
  return copy;
}

export const ObjectHelpers = { omit, pick };
